export const adminScreenshots = {
  bookings: [
    {
      headerText: "Bookings List",
      fileName: {
        mobile: "bookingsList.png",
        desktop: "bookingsList.png",
      },
      alt: "Screenshot of Admin Bookings List View",
    },
    {
      headerText: "Room Availabilities",
      fileName: {
        mobile: "cloudJumperAvailability.jpg",
        desktop: "cloudJumperAvailability.jpg",
      },
      alt: "Screenshot of Admin Room Availabilities",
    },
  ],
  products: [
    {
      headerText: "Products List",
      fileName: {
        mobile: "productsList.png",
        desktop: "productsList.png",
      },
      alt: "Screenshot of Admin List of All Products",
    },
    {
      headerText: "Product Form",
      fileName: {
        mobile: "productsForm.png",
        desktop: "productsForm.png",
      },
      alt: "Screenshot of Admin Form to Add a Product",
    },
  ],
  rooms: [
    {
      headerText: "Rooms List",
      fileName: {
        mobile: "roomsList.png",
        desktop: "roomsList.png",
      },
      alt: "Screenshot of Admin List of All Rooms",
    },
    {
      headerText: "Room Form",
      fileName: {
        mobile: "roomsForm.png",
        desktop: "roomsForm.png",
      },
      alt: "Screenshot of Admin Form To Add A Room",
    },
  ],
  addOns: [
    {
      number: 1,
      headerText: "Add-Ons List",
      fileName: {
        mobile: "addOnsList.png",
        desktop: "addOnsList.png",
      },
      alt: "Screenshot of Admin List of All Add-Ons",
    },
    {
      number: 2,
      headerText: "Add-On Form",
      fileName: {
        mobile: "addOnsForm.png",
        desktop: "addOnsForm.png",
      },
      alt: "Screenshot of Admin Form to Add an Add-On",
    },
  ],
};